import { useState } from 'react';

import { signaalTypes } from '@/components/sidebar/signalen/SignalenRow';

export const useSignaalTypenSearch = (initialValueSignaalTypen: string[] = []) => {
  const createOption = (label: string) => ({
    label,
    value: label,
  });

  const [selectedSignaalTypen, setSelectedSignaalTypen] = useState<string[]>(initialValueSignaalTypen);

  const lijstVanSignaalTypen = (Object.values(signaalTypes) as string[]).sort((a, b) => a.localeCompare(b));
  const signaalTypenOptions = ['Alle signaaltypes toevoegen']
    .concat(...lijstVanSignaalTypen)
    .map((item) => createOption(item));

  const handleSignaalTypenChange = (selectedOptions) => {
    if (selectedOptions.includes('Alle signaaltypes toevoegen')) {
      setSelectedSignaalTypen((prevSelected) => [
        ...prevSelected,
        ...lijstVanSignaalTypen.filter((item) => !prevSelected.includes(item)),
      ]);
    } else setSelectedSignaalTypen(selectedOptions);
  };

  return { selectedSignaalTypen, handleSignaalTypenChange, setSelectedSignaalTypen, signaalTypenOptions };
};
